import { Alert, Box, Button, Typography } from "@mui/material";
import { PhotoEvent } from 'common-models';
import { FC } from 'react';

interface EventDangerZonePanelProps {
    photoEvent: PhotoEvent;
    onDeleteEvent: () => void;
}

const EventDangerZonePanel: FC<EventDangerZonePanelProps> = ({
    photoEvent,
    onDeleteEvent
}) => {
    return (
        <Box className='event-gallery-admin-area-frame'>
            <Typography variant="h2" component="h2" gutterBottom color="error">
                Danger Zone
            </Typography>

            <Alert severity="warning" sx={{ mb: 2 }}>
                <Typography variant="body2">
                    <strong>Warning:</strong> Deleting an event is permanent and cannot be undone.
                    All photos and associated data will be permanently removed.
                </Typography>
            </Alert>

            <Button
                variant='contained'
                color='error'
                onClick={onDeleteEvent}
                size="large"
            >
                Delete Event: "{photoEvent.title}"
            </Button>
        </Box>
    );
};

export default EventDangerZonePanel;
